import { East } from "@mui/icons-material";
import { Link } from "react-router-dom";
import Duration from "../../images/internship/duration.png";
import Members from "../../images/internship/members.png";
import Slots from "../../images/internship/slots.png";
import Stipend from "../../images/internship/stipend.png";
import toList from "../utils/ComponentUtil";
import './InternshipPage.scss';

function InternshipCard(intern) {
    return (
        <div className="internship">
            <Link reloadDocument={true} to={intern?.to || '/internships/' + intern?.id}>
                <div className="title">{intern?.title}</div>
                <div className="name-wrp">
                    <div className="name">{intern?.name}</div>
                    <div className="date">Posted On: {intern?.postedOn}</div>
                </div>
                <div className="details">
                    <div className="detail">
                        <img className="img" src={Stipend} alt="img" />
                        <div className="name">Stipend:</div>
                        <div className="unit">{intern?.stipend}</div>
                    </div>
                    <div className="detail">
                        <img className="img" src={Duration} alt="img" />
                        <div className="name">Duration:</div>
                        <div className="unit">{intern?.duration}</div>
                    </div>
                    <div className="detail">
                        <img className="img" src={Members} alt="img" />
                        <div className="name">Members Working:</div>
                        <div className="unit">{intern?.members}</div>
                    </div>
                    <div className="detail">
                        <img className="img" src={Slots} alt="img" />
                        <div className="name">Slots Remaining:</div>
                        <div className="unit">{intern?.slotsRemaining}</div>
                    </div>
                </div>
                <div className="skills-needed">
                    <div className="skills">
                        <div className="heading">Skills Needed:</div>
                        {
                            toList(intern?.skillsNeeded?.slice(0, 4), undefined, (item, i) =>
                                <div className="skill" key={i}>
                                    <div className="name">{item}</div>
                                </div>)
                        }
                        {intern?.skillsNeeded?.length > 4 && <div className="more-skills">+{intern?.skillsNeeded?.length - 4} more</div>}
                    </div>
                </div>
                <div className="view-details">
                    View details
                    <East/>
                </div>
            </Link>
        </div>
    );
}

export default InternshipCard;
